module.exports = __webpack_public_path__ + "static/media/Arcadia-Ridge-Bylaws.1aafe288.pdf";